
<template>
  <div class="form-body">
    <div class="row bottom-space" v-if="clonedEvent.type == 'event' && isNew">
        <div class="col-md-12">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="periodic" v-model="clonedEvent.periodic">
                <label class="custom-control-label float-left" for="periodic">{{ $t("labels.periodic") }}</label>
            </div>
        </div>
    </div>
    <div class="row" v-if="clonedEvent.periodic">
        <div class="col-md-4">
            <div class="form-group">
                <label for="periodStart">{{ $t("labels.periodStart") }}</label>
                <date-picker v-model="clonedEvent.periodStart" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="periodEnd">{{ $t("labels.periodEnd") }}</label>
                <date-picker v-model="clonedEvent.periodEnd" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="periodStep">{{ $t("labels.periodStep") }}</label>
                <select class="form-control" v-model="clonedEvent.periodStep">
                    <option value="days">{{ $t("labels.days") }}</option>
                    <option value="weeks">{{ $t("labels.weeks") }}</option>
                    <option value="months">{{ $t("labels.months") }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row" v-if="clonedEvent.periodStep === 'days' && clonedEvent.periodic === true">
        <div class="col-md-6">
            <div class="form-group">
                <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                <date-picker v-model="clonedEvent.dailyStart" width="100%" type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                <date-picker v-model="clonedEvent.dailyEnd" width="100%"  type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
            </div>
        </div>
    </div>
    <div class="row" v-if="clonedEvent.periodStep === 'weeks' && clonedEvent.periodic === true">
        <div class="col-md-4">
            <div class="form-group">
                <label for="dayOfWeek">{{ $t("labels.dayOfWeek") }}</label>
                <select class="form-control" v-model="clonedEvent.dayOfWeek">
                    <option value="1">{{ $t("labels.monday") }}</option>
                    <option value="2">{{ $t("labels.tuesday") }}</option>
                    <option value="3">{{ $t("labels.wednesday") }}</option>
                    <option value="4">{{ $t("labels.thursday") }}</option>
                    <option value="5">{{ $t("labels.friday") }}</option>
                    <option value="6">{{ $t("labels.saturday") }}</option>
                    <option value="7">{{ $t("labels.sunday") }}</option>
                </select>
            </div>
        </div>
        <div class="col-md-4">
        <div class="form-group">
                <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                <date-picker v-model="clonedEvent.dailyStart" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
            </div>
        </div>
        <div class="col-md-4">
        <div class="form-group">
                <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                <date-picker v-model="clonedEvent.dailyEnd" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
            </div>
        </div>
    </div>
    <div class="row" v-if="clonedEvent.periodStep === 'months' && clonedEvent.periodic === true">
      <div class="col-md-4">
          <div class="form-group">
              <label for="dayType">{{ $t("labels.dayType") }}</label>
              <select class="form-control" v-model="clonedEvent.dayType">
                  <option value="sameday">{{ $t("labels.sameDay") }}</option>
                  <option value="samedayofweek">{{ $t("labels.sameDayOfWeek") }}</option>
              </select>
          </div>
      </div>
      <div class="col-md-4" v-if="clonedEvent.dayType === 'sameday'">
          <div class="form-group">
              <label for="dayOfMonth">{{ $t("labels.dayOfMonth") }}</label>
              <input type="number" class="form-control" v-model="clonedEvent.dayOfMonth">
          </div>
      </div>
      <div class="col-md-4" v-if="clonedEvent.dayType === 'samedayofweek'">
          <div class="form-group">
              <label for="weekOfMonth">{{ $t("labels.weekOfMonth") }}</label>
              <select class="form-control" v-model="clonedEvent.weekOfMonth">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
              </select>
          </div>
      </div>
      <div class="col-md-4" v-if="clonedEvent.dayType === 'samedayofweek'">
        <div class="form-group">
          <label for="dayOfWeek">{{ $t("labels.dayOfWeek") }}</label>
          <select class="form-control" v-model="clonedEvent.dayOfWeek">
              <option value="1">{{ $t("labels.monday") }}</option>
              <option value="2">{{ $t("labels.tuesday") }}</option>
              <option value="3">{{ $t("labels.wednesday") }}</option>
              <option value="4">{{ $t("labels.thursday") }}</option>
              <option value="5">{{ $t("labels.friday") }}</option>
              <option value="6">{{ $t("labels.saturday") }}</option>
              <option value="7">{{ $t("labels.sunday") }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
            <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
            <date-picker v-model="clonedEvent.dailyStart" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
            <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
            <date-picker v-model="clonedEvent.dailyEnd" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm a' : 'HH:mm'" placeholder="Select Time" :time-picker-options="clonedEvent.type == 'event' ? {start: '00:00', step:'00:01' , end: '23:59'} : {}" confirm></date-picker>
        </div>
      </div>
    </div>
     <div class="row" v-if="!clonedEvent.periodic">
        <div class="col-md-4" >
            <div class="form-group">
                <label for="date">{{ $t("labels.startDate") }}</label>
                <date-picker v-model="clonedEvent.startDate" :lang="$i18n.locale" width="100%" type="datetime" :popupStyle="{top: 30, left: 0}" :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" :minute-step="1" confirm></date-picker>
            </div>
        </div>
          <div class="col-md-4">
            <div class="form-group">
                <label for="date">{{ $t("labels.endDate") }}</label>
                <date-picker v-model="clonedEvent.endDate" :lang="$i18n.locale" width="100%" type="datetime" :popupStyle="{top: 30, left: 0}" :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" :minute-step="1" confirm></date-picker>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label for="type"><span class="required">*</span>{{ $t("labels.type") }}</label>
                <select class="form-control" @change="$emit('update:typeId',$event.target.value)">
                    <option v-for="tp in clonedTypeList" :value="tp._id" :key="tp._id" :selected="tp._id == typeId">{{ tp.name[$i18n.locale] ? tp.name[$i18n.locale] : tp.name['en'] }}</option>
                    <option value="other" >{{ $t("labels.other") }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row" v-if="clonedEvent.type === 'event' && typeId ==='other'">
        <div class="col-md-12">
            <div class="form-group">
                <label for="eventNotes">{{ $t("labels.other") }}</label>
                <textarea id="eventNotes" class="form-control" v-model="otherText"></textarea>
            </div>
        </div>
    </div>
    <div class="row" v-if="!clonedEvent.periodic">
        <div class="col-md-6">
            <div class="dropzone image-upload bottom-space">
                <h5>
                    {{ $t("labels.addSingleImage") }}
                    <span><strong>{{ $t('labels.maxImageSize') }}:</strong><br>5 Mb</span>
                    <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedImageTypesSimple.toString().split(',').join(', ') }}</span>
                </h5>
                <input type="file" id="image" ref="image" @change="getImage">
            </div>
        </div>
        <div class="col-md-6">
            <div class="input-group">
                <div class="dropzone bottom-space">
                    <h5>
                        {{ $t("labels.video") }}
                        <span><strong>{{ $t('labels.maxVideoSize') }}:</strong><br>50 Mb</span>
                        <span><strong>{{ $t('labels.allowedFormats') }}:</strong><br>{{ $store.state.allowedVideoTypesSimple.toString().split(',').join(', ') }}</span>
                    </h5>
                    <input type="file" id="video" ref="video" @change="getVideo">
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="row" v-if="imageUrl">
                <div class="col-md-10">
                    <figure>
                        <img :src="imageUrl" alt="index">
                        <figcaption>{{ imageName }}</figcaption>
                    </figure>
                </div>
                <div class="col-md-2">
                    <a class="warning p-0" @click.prevent="deleteImage"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row" v-if="videoUrl">
                <div class="col-md-10">
                    <figure>
                        <video  controls>
                            <source :src="videoUrl" />
                        </video>
                      <figcaption>{{ videoName }}</figcaption>
                    </figure>
                     
                </div>
                <div class="col-md-2">
                    <a class="warning p-0" @click.prevent="deleteVideo"><i class="fa fa-trash font-medium-3 mr-2"></i></a>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
            <label for="eventNotes">{{ $t("labels.notes") }}</label>
            <textarea id="eventNotes" class="form-control" v-model="clonedEvent.notes"></textarea>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
    props: {
      isNew: {
        type: Boolean,
        default: true,
      },
      event: {
        type: Object,
        default: () => {}
      },
      typeList: {
        type: Array,
        default: []
      },
      typeId: {
        type: String
      }
    },
    data(){
        return {
            date: null,
            hour: null,
            clonedEvent: {},
            clonedTypeList: [],
            video: {},
            image: {},
            persistedVideo: {},
            persistedImage: {}
        }
    },
    methods: {
      changePeriodicValue:  function(event) {
        console.log('changePeriodicValue -->', this.clonedEvent.periodic) 
        if (this.clonedEvent) {
          this.clonedEvent = Object.assign({}, this.clonedEvent, { periodic: !this.clonedEvent.periodic})
        }else {
          this.clonedEvent = Object.assign({}, this.clonedEvent, { periodic: true })
        }
      },
      translatedAppointmentType: function(eventType){      
        return this.$t(`lovTypes.${eventType}`)
      },
      fullDate() {
          let date = this.date + ' ' + this.hour
          this.event.date = new Date(date)
      },
      timeFormat(d) {
          return moment(d).format('hh:mm:ss a')
      },
      getVideo() {
          if (this.$refs.video.files.length > 0) {
              this.video = this.$refs.video.files[0]
              this.event.video = this.$refs.video.files[0]
          }
      },
      deleteVideo() {
          this.$refs.video.value = ''
          this.video = {}
          delete this.event.video
      },
      getImage() {
          this.event.image = this.$refs.image.files[0]
          this.image = this.$refs.image.files[0]
      },
      getUrl(img) {
        try {
          return URL.createObjectURL(img)
        }catch(e) {
          return ''
        }
      },
      deleteImage() {
          this.$refs.image.value = ''
          this.image = {}
          delete this.event.image
      },
    },
    computed: {
      imageUrl: function() {
        if (this.persistedImage != {})
          return this.persistedImage['signed_url']
        else
          return this.getUrl(this.image)
      },
      imageName: function() {
        if (this.persistedImage != {})
          return this.persistedImage['originalname']
        else
          return this.image.name
      },
      videoUrl: function() {
        if (this.persistedVideo != {})
          return this.persistedVideo['signed_url']
        else
          return this.getUrl(this.video)
      },
      videoName: function() {
        if (this.persistedVideo != {})
          return this.persistedVideo['originalname']
        else
          return this.video.name
      },
    },
    watch: {
      'event':  {
        handler: function(newValue) {
          console.log(newValue)

          if (Object.keys(newValue).length > 0) {
            this.clonedEvent = Object.assign({}, newValue, { patientId: typeof newValue.patientId === 'string' ? newValue.patientId : newValue.patientId._id })
            if (typeof newValue.video === 'object') {
              this.persistedVideo = newValue.video
            }else {
              this.persistedVideo = {}
            }
            if (typeof newValue.image === 'object') {
              this.persistedImage = newValue.image
            }else {
              this.persistedImage = {}
            }
          }
        },
        deep: true
      },
      'typeList': {
        handler: function(newValue) {
          this.clonedTypeList = newValue
          if (this.typeId == '' && newValue.length) {
            this.$emit('update:typeId', newValue[0]._id)
          }
        },
      },
      'clonedEvent.periodic': function(newValue) {
        if (newValue) {
          this.clonedEvent = Object.assign({}, this.clonedEvent, {
            periodStart: moment(this.clonedEvent.startDate).format('YYYY-MM-DD'), 
            periodEnd:   moment(this.clonedEvent.endDate).format('YYYY-MM-DD'),
            dailyStart:  moment(this.clonedEvent.startDate), 
            dailyEnd:    moment(this.clonedEvent.endDate)
          })
        }else {
          this.clonedEvent = Object.assign({}, this.clonedEvent, { 
            startDate: moment(this.clonedEvent.startDate),
            endDate:   moment(this.clonedEvent.endDate)
          })
        }
      },
      'video': {
        handler: function(newValue) {
          this.$emit('updatedmediaevent', Object.assign({}, this.clonedEvent, {image: this.image, video: newValue }))
        },
        deep: true
      },
      'image': {
        handler: function(newValue) {
          this.$emit('updatedmediaevent', Object.assign({}, this.clonedEvent, {image: newValue, video: this.video }))
        },
        deep: true
      }
    }
}
</script>